// extracted by mini-css-extract-plugin
module.exports = {"main":"main-layout_main__Jrj5x","header":"main-layout_header__mpzz1"};